
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/typescript",
      function () {
        return require("private-next-pages/material-ui/guides/typescript.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/typescript"])
      });
    }
  